export const PREVIEW_EMAIL_OVERRIDE_STORAGE_KEY =
    "hc-preview-email-override";

export const PREVIEW_EMAIL_OVERRIDE_HEADER =
    "x-hc-preview-email-override";

const normalizePreviewEmail = (value: string): string => value.trim().toLowerCase();

const isValidEmail = (value: string): boolean =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

const getSessionStorage = (): Storage | undefined => {
    if (typeof window === "undefined") {
        return undefined;
    }

    return window.sessionStorage;
};

export const isPreviewEnvironment = (): boolean => {
    const envValue =
        import.meta.env.VITE_HC_DEPLOY_ENV?.trim().toLowerCase() ?? "";

    return envValue === "preview";
};

export const getStoredPreviewEmailOverride = (): string | null => {
    const sessionStorage = getSessionStorage();
    if (!sessionStorage) {
        return null;
    }

    const rawValue = sessionStorage.getItem(PREVIEW_EMAIL_OVERRIDE_STORAGE_KEY);
    const normalized =
        typeof rawValue === "string" ? normalizePreviewEmail(rawValue) : "";
    return isValidEmail(normalized) ? normalized : null;
};

export const setStoredPreviewEmailOverride = (rawEmail: string): void => {
    const sessionStorage = getSessionStorage();
    if (!sessionStorage) {
        return;
    }

    const normalized = normalizePreviewEmail(rawEmail);
    if (!normalized || !isValidEmail(normalized)) {
        sessionStorage.removeItem(PREVIEW_EMAIL_OVERRIDE_STORAGE_KEY);
        return;
    }

    sessionStorage.setItem(PREVIEW_EMAIL_OVERRIDE_STORAGE_KEY, normalized);
};

export const clearStoredPreviewEmailOverride = (): void => {
    const sessionStorage = getSessionStorage();
    if (!sessionStorage) {
        return;
    }

    sessionStorage.removeItem(PREVIEW_EMAIL_OVERRIDE_STORAGE_KEY);
};
